// extracted by mini-css-extract-plugin
export default {"wrapperSmall":"wrapperSmall--WEQeA"};